<template>
  <base-modal size="xl" hide-header hide-footer @close="close" no-padding>
    <div class="col-sm-12 p-3" @click.stop="">
      <div class="col-12">
        <h2>{{ getTitle(assignment) }}</h2>
        <div class="col-sm-12 p-2">
          <Flicking
            v-if="photos.length > 0"
            ref="flicking"
            :options="options"
            :plugins="plugins"
            class="flicking-panel pointer nopads text-center"
            style="height: 60vh"
          >
              <div
                v-for="(photo, index) in photos"
                :key="index"
                class="relative nopads stat-map-container slide-img-container"
              >
                  <ImageView
                    ref="image"
                    :img-size="'lg'"
                    :url="photo.url"
                    :base64data="photo.src"
                    :contain="true"
                    :show-download-button="true"
                    @click="openImage"
                    @download-image="handleDownload"
                  />
              </div>
              <template #viewport>
                  <span class="flicking-arrow-prev"></span>
                  <span class="flicking-arrow-next"></span>
              </template>
          </Flicking>
          <div class="col-12 nopads pt-1">
            <span class="item-detail-text">{{ getAssignmentInfo(assignment) }}</span>
          </div>
          <div class="col-sm-12 button-container pb-3">
            <button class="btn btn-secondary form-button" @click.stop="close">{{ $t('common.close') }}</button>
          </div>
        </div>
        <!-- Comments container just to get photos from them -->
        <comment-container
            ref="comments"
            :topic="commentTopics.TOPIC_WORK_ASSIGNMENT"
            :id="assignment.id"
            :custom-api-url="workAssignmentCommentUrl"
            :user="user"
            class="hidden"
            @commentsReady="initPhotos"
        />

        <!-- Fullscreen photo -->
        <Transition name="fade">
          <fullscreen-image
            v-if="fullScreenPhotoData"
            :large-images="fullScreenPhotoData"
            :save-disabled="false"
            :photo-ids="fullScreenPhotoIds"
            :panel-index="panelIndex"
            :controls="true"
            @close="closePhoto"
          />
        </Transition>
      </div>
    </div>
  </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin.js"
import "@egjs/vue3-flicking/dist/flicking.css";
import Flicking from "@egjs/vue3-flicking";
import { Arrow } from "@egjs/flicking-plugins"
import "@egjs/flicking-plugins/dist/arrow.css";
import ImageView from "@/components/view/ImageView.vue";
import FullscreenImage from "@/components/view/FullscreenImage.vue";
import RoadAddessView from "@/components/velho/RoadAddressView";
import BaseModal from "@/components/BaseModal";
import CommentContainer from "../comments/CommentContainer.vue";
import {commentTopics} from "@/components/mixins/CommentMixin";
import { downloadHelper } from '../mixins/DownloadMixin'

export default {
    name: 'WorkAssignmentPhotoViewer',
    components: {CommentContainer, BaseModal, RoadAddessView, FullscreenImage, ImageView, Flicking},
    mixins: [restApi, workAssignmentHelper, downloadHelper],
    props: {
        assignment: {
            type: Object,
            default() {
                return null
            }
        }
    },
    data: function () {
        return {
            plugins: [new Arrow()],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
            fullScreenPhotoData: undefined,
            fullScreenPhotoIds: [],
            panelIndex: 0,
            photos: []
        }
    },
    computed: {
        commentTopics() {
            return commentTopics
        }
    },
    methods: {
        initPhotos() {
            this.photos = this.getAssignmentPhotos(this.assignment, this.$refs.comments.getPhotos())
        },

        close: function () {
            this.assignmentMode = false
            this.$emit('close')
        },
        openImage: function () {
            const flicking = this.$refs.flicking
            const imageData = this.$refs.image
            this.fullScreenPhotoData = []
            imageData.forEach((src, index) => {
                this.fullScreenPhotoData.push(src)
                this.fullScreenPhotoIds.push(this.observation.photos[index].id)
            })
            this.panelIndex = flicking.index

        },
        closePhoto() {
            this.fullScreenPhotoData = undefined
        },
        async handleDownload({ url, id }) {
            try {
                const response = await fetch(url, { 
                    method: 'GET',
                    headers: { 'Accept': 'image/*' }
                })
                if (response.ok) {
                    const blob = await response.blob()
                    const fileName = `assignment_photo_${id}.jpg`
                    this.downloadFile({ data: blob, headers: { 'Content-Type': blob.type } }, fileName)
                }
            } catch (error) {
                console.error('Download failed:', error)
            }
        }
    }
}
</script>
<style scoped>
</style>
